import { faUser } from "@fortawesome/free-solid-svg-icons";
import { isPositiveNumber } from "et3-type-guards";
import React from "react";
import i18n from "../../../../constants/i18n";
import getPromoCodeUsageStore from "../../../../stores/user-store/promocode-code-usage-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../../core/et3-div";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const UserPromoCodeUsageForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"number"}
          icon={faUser}
          label={i18n.get("USER_ID")}
          placeHolder={i18n.get("USER_ID")}
          value={getPromoCodeUsageStore().promoCodeUsageUserid.get()}
          onChoose={(value: number) =>
            getPromoCodeUsageStore().promoCodeUsageUserid.set(value)
          }
          onBlur={() => {}}
          onEnter={() => {
            getPromoCodeUsageStore().getUserPromoCodeUsage();
          }}
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={[
            { label: "10", value: "10" },
            { label: "50", value: "50" },
            { label: "100", value: "100" },
            { label: "250", value: "250" }
          ]}
          value={getPromoCodeUsageStore().promoCodeUsageLimit.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getPromoCodeUsageStore().setPromoCodeUsageLimit(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={isPositiveNumber(
          getPromoCodeUsageStore().promoCodeUsageUserid.get()
        )}
        onClick={async () =>
          await getPromoCodeUsageStore().getUserPromoCodeUsage()
        }
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default UserPromoCodeUsageForm;
